<template>
  <div class="home">

    <!-- 顶部条  -->
    <div class="company-top">
      <div class="company-title">揭阳市泽昊健康管理有限公司</div>
      <div class="company-btns">
        <div class="btns-home" @click="companyBtnAction(0)">首页</div>
        <div class="btns-home" @click="companyBtnAction(1)">公司介绍</div>
        <div class="btns-home" @click="companyBtnAction(2)">公司愿景</div>
        <div class="btns-home" @click="companyBtnAction(3)">联系我们</div>
        <div id="select-line" :style="{left: left}"></div>
      </div>
    </div>

    <!-- 首页 -->
    <div class="company-page" id="company-home">

    </div>

    <!-- 介绍 -->
    <div class="company-page" id="company-introduct">
      <div class="title">公司介绍</div>
      <div class="sub-title">INTRODUCTION</div>
      <div class="line"></div>
      <div class="content">&nbsp;&nbsp;&nbsp;&nbsp;揭阳市泽昊健康管理有限公司成立于2020年01月06日，立足于公共卫生与大众健康的交汇点，致力于为社会各界提供全面、专业、高效的健康管理服务。公司凭借深厚的行业经验和创新的技术应用，成功打造了公卫助手应用，成为公共卫生领域的重要一员。展望未来，健康管理有限公司将继续加大研发力度，不断优化公卫助手应用的功能和性能，为用户提供更加便捷、高效的健康管理服务。同时，我们将积极拓展市场，与更多的合作伙伴携手共进，共同开创公共卫生事业的新篇章。</div>
    </div>
    
    <!-- 愿景 -->
    <div class="company-page" id="company-mission">
      <div class="title">公司愿景</div>
      <div class="sub-title">OUR MISSION</div>
      <div class="line"></div>
      <div class="content">&nbsp;&nbsp;&nbsp;&nbsp;我们致力于成为行业领先的健康服务提供商，我们坚信，通过专业的健康管理服务和创新的健康科技应用，能够帮助每个人实现全方位、个性化的健康目标。我们致力于打造一个健康、快乐、充满活力的社会，让每个人都能享受到健康带来的美好生活。</div>

    </div>


    <!-- 联系我们  -->
    <div class="company-bottom">
      <div>地址：揭阳市榕城区东升街道东泮村兴社路华贸大厦602号</div>
      <div>联系邮箱：quanhejiankang@163.com</div>
      <!-- <div>联系电话</div> -->
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue"

document.title = "揭阳市泽昊健康管理有限公司"

const activeIndex = ref(0)
const left = ref(0)


watch(activeIndex, (e)=>{
  scrollToIndex(e)
})

function companyBtnAction(idx) {
  window.scrollTo({
    top: idx * document.documentElement.clientHeight,
    behavior: 'smooth' // 平滑滚动
  });
}

function scrollHandler(e) {
  const currentScrollY = document.documentElement.scrollTop||document.body.scrollTop
  const screenHeight = document.documentElement.clientHeight
  const idx = Math.floor((currentScrollY - 10 + screenHeight) / screenHeight)

  // console.log('---------', currentScrollY, idx)
  if (activeIndex.value != idx) {
    activeIndex.value = idx
  }
}


function scrollToIndex(idx) {
  const btnsEls = document.getElementsByClassName('btns-home')
  const lineEl = document.getElementById('select-line')
  const btnEl = btnsEls[idx]

  const offsetWid = btnEl.getBoundingClientRect().width / 2 - lineEl.getBoundingClientRect().width / 2
  let offsetLeft = 0
  for (let i = 0; i < idx; i++) {
    offsetLeft += btnsEls[i].getBoundingClientRect().width
  }
  left.value = offsetLeft + offsetWid + 'px'
}

onMounted(() => {
  scrollToIndex(0)
  // 监听滚动
  window.addEventListener('scroll', scrollHandler)
})
onUnmounted(() => {
  // 移除监听
  window.removeEventListener('scroll', scrollHandler)  
})



</script>

<style lang="scss" scoped>
.home {
  height: 100%;

  .company-top {
    position: fixed;
    top: 0;
    width: 100%;
    background: #ffffff;
    height: 6vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
    .company-title {
      font-size: 1.3vw;
      font-weight: 500;
      padding-left: 5.2vw;
      color: #0B7C9A;
    }
    .company-btns {
      // width: 15vw;
      margin-right: 5vw;
      display: flex;
      position: relative;
      .btns-home {
        font-size: 1.2vw;
        font-weight: 500;
        color: #333;
        // height: 3vw;
        width: 8vw;
        text-align: center;
        cursor: pointer;
      }
      #select-line {
        position: absolute;
        height: 5px;
        width: 2vw;
        background: #0B7C9A;
        bottom: -1vh;
      }
    }
  }

  .company-page {
    height: 100vh;
    text-align: center;
    font-weight: 500;
    .title {
      padding-top: 6vw;
      font-size: 2.5vw;
    }
    .sub-title {
      margin-top: 0.5vw;
      font-size: 1.3vw;
      color: #666;
    }
    .line {
      background: #0B7C9A;
      height: 5px;
      width: 5vw;
      margin: 0 auto;
      margin-top: 0.6vw;
    }
    .content {
      border-radius: 2vw;
      padding: 1.5vw;
      width: 60vw;
      // height: 50vh;
      margin: 0 auto;
      margin-top: 5vw;
      background: rgba($color: #fff, $alpha: 0.7);
      font-size: 1.5vw;
      line-height: 2.5vw;
      text-align: left;
      font-weight: 400;
      
    }
  }

  #company-home {
    background-image: url('../assets/bg.png');
    background-size: 100% 100%;
  }
  #company-introduct {
    background-image: url('../assets/bg2.png');
    background-size: 100% 100%;
  }
  #company-mission {
    background-image: url('../assets/bg3.jpg');
    background-size: 100% 100%;
    position: relative;

  }
  .company-bottom {
    height: 8vh;
    background: rgba($color: #000000, $alpha: 0.3);
    width: 100%;
    display: flex;
    color: white;
    justify-content: space-around;
    font-size: 1.2vw;
    font-weight: 400;
    align-items: center;
  }

}
</style>
